import * as React from "react";
import { isNative } from "@/lib/platform";

const MOBILE_BREAKPOINT = 768;

/**
 * true = Handy-Layout (Tabs + Fußleiste).
 *
 * In der nativen App (nur iPhone, TARGETED_DEVICE_FAMILY 1) gilt IMMER das Handy-Layout, auch
 * wenn der Bildschirm 768 px oder breiter ist: iPhone im Querformat (bis 956 pt) und das iPad,
 * das die iPhone-App im Kompatibilitätsmodus zeigt. Sonst schaltet der Kundenbereich auf das
 * Desktop-Layout um, die Fußleiste verschwindet und es gibt keine Navigation mehr
 * (Apple-Ablehnung 12.10.2026, Guideline 4, iPad Air 11", „menu at the top was not visible“).
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);
  const nativ = isNative();

  React.useEffect(() => {
    if (nativ) return;
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(mql.matches);
    };
    mql.addEventListener("change", onChange);
    // Use mql.matches instead of window.innerWidth to avoid forced reflow
    setIsMobile(mql.matches);
    return () => mql.removeEventListener("change", onChange);
  }, [nativ]);

  return nativ || !!isMobile;
}
